import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { LabMDM } from '../../app/masterdata/models/lab';
import { MessagesService } from '../../app/messages/messages.service';
import { DatePipe } from '@angular/common';
import { saveAs as saveByFileSaver } from "file-saver";
import { LibprepWorkfilesService } from './libprep-workfiles.service';

@Component({
  selector: 'app-libprep-workfiles',
  templateUrl: './libprep-workfiles.component.html',
  styleUrls: ['./libprep-workfiles.component.css']
})
export class LibprepWorkfilesComponent implements OnInit {

  @ViewChild('topDiv') elementView: ElementRef;
  selectedLabId: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  loading: boolean = false;
  scrollableCols: any[];
  puid = localStorage.getItem('PUID');
  selectedLab: LabMDM;
  libprepworkfilesTotal: any[];
  libprepworkfiles: any[];
  libprepworkfilesDuplicate: any[];
  blocked: boolean = false;
  tableFilterValue:any =null;
  sortOrderflag : boolean = true;
  rowsCount : any = 0;
  divHeight: number;
  scrollHeight: string;
  fromDate: Date;
  toDate: Date;
  maxDate: Date;
  dateFormat: string;

  constructor(private libprepworkfileservice: LibprepWorkfilesService, private _messagesService: MessagesService,private datePipe: DatePipe) { }
  setDateFormat(dateFormat){
    return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
  }
  ngOnInit() {
    this.selectedLab = JSON.parse(localStorage.getItem('lab')).lab;
    this.dateFormat =this.setDateFormat(this.selectedLab.dateFormat.toLowerCase());
    this.selectedLabId = this.selectedLab._id;
    this.puid = localStorage.getItem('PUID');
    this.scrollableCols = [
      { 'header': 'File Name', 'field': 'fileName', 'selected': false },
      { 'header': 'Time Stamp', 'field': 'creationDate', 'selected': false },
      { 'header': 'User PUID', 'field': 'puid', 'selected': false },
      { 'header': 'Process', 'field': 'process', 'selected': false },
      { 'header': 'Process Step', 'field': 'processStep', 'selected': false },
      { 'header': 'Batch Id', 'field': 'batchId', 'selected': false },
      { 'header': 'Source Plate Barcode', 'field': 'sourcePlate', 'selected': false },
      { 'header': 'Target Plate Barcode', 'field': 'targetPlate', 'selected': false }
    ]
    this.maxDate = new Date();
    this.refreshTableData();
  }
  getDefaultDate(date: Date, delta: number) {
    date.setDate(date.getDate() + delta);
    return date;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (this.elementView != undefined) {
      this.scrollHeight = document.documentElement.clientHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight - 150+ 'px';
      this.divHeight = window.innerHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight-150;
    }
  }
  private handleError(error: any) {
    this.loading = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getDate(date: any) {
      if(date && date["$date"]) {
        return this.datePipe.transform(new Date(date["$date"]), this.selectedLab.dateTimeFormat);
      }else {
      return null;
    }
  }

  filterGlobal(value){
    if (value) {
      this.libprepworkfiles=this.globalFilter(this.libprepworkfilesDuplicate, value);
    } else {
      this.libprepworkfiles = [...this.libprepworkfilesDuplicate];
    }
  }
  globalFilter(itemList: any, searchKeyword: string) {
    let filteredList = [];
    if (itemList.length > 0) {
      searchKeyword = searchKeyword.replace(/\s/g, '').toLowerCase();
      itemList.forEach(item => {
        let propValueList = Object.values(item);
        for (let probVal of propValueList) {
        if(this.checkForTimeStampDate(item, searchKeyword)){
          filteredList.push(item);
          break;
        }
        if (this.getCheckForOtherData(probVal,searchKeyword)) {
          filteredList.push(item);
          break;
        }
        }
      });
      return filteredList;
    }
  }
  checkForTimeStampDate(item: any, searchKeyword: string) {
    return item.creationDate && this.getCheckForOtherData(this.getDate(item.creationDate), searchKeyword);
  }
  getCheckForOtherData(probVal :any,searchKeyword:any){
    return (probVal && probVal.toString().replace(/\s/g, '').toLowerCase().indexOf(searchKeyword) > -1);
  }

  sortColumnheader(flag,field){
    if(field == 'fileName' || field == 'creationDate'){
        this.libprepworkfiles.sort((wf1, wf2) => {
          let dateA:any
          let dateB:any
           dateA = this.returnForDate(wf1);
          dateB = this.returnForDate(wf2) ;
          return this.returnFileName(flag, dateB, dateA);
        })
    }else{
        this.libprepworkfiles.sort((data1, data2) => {
          data1[field] = data1[field] ? data1[field] : "";
          data2[field] = data2[field] ? data2[field]: "";
          if(data1[field] > data2[field]) {
            return this.returnData1(flag);
          } else if(data1[field] < data2[field]) {
            return this.returnData2(flag);
          } else {
            return 0;
          }
        });
    }
   this.sortOrderflag= !flag;
  }

  returnData2(flag: any): number {
    return flag ? 1 : -1;
  }

  returnData1(flag: any): number {
    return flag ? -1 : 1;
  }

  returnFileName(flag: any, dateB: any, dateA: any): number {
    return flag ? dateB - dateA : dateA - dateB;
  }

  returnForDate(wf: any): any {
    return wf['creationDate'] && wf['creationDate']['$date'] ? this.checkForTimeStamp(wf) : '';
  }

  checkForTimeStamp(wf: any): any {
    return new Date(wf['creationDate']['$date']).getTime();
  }

  downloadFilesFromAzure(fileName){
    this.libprepworkfileservice.downloadFilesFromAzure(this.selectedLab.name,fileName).subscribe(
      result => {
        let blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        let blobTxt: Blob = new Blob([blob], { type: 'application/octet-stream' });
        saveByFileSaver(blobTxt, fileName);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'Workfile has been downloaded',
        });
        this.blocked = false;
    },
    error => {
      this.handleError(error);
    });
  }
  disableSearch(){
    if(!this.fromDate || !this.toDate){
      return true
    }
      return false;
  }

  onApplyFilter() {
    this.libprepworkfiles =[];
    this.libprepworkfilesDuplicate =[];
    this.tableFilterValue =null;
    let requestObj = {};
    let toFilterDate = new Date(this.toDate.getTime());
    toFilterDate.setDate(toFilterDate.getDate() + 1)
    requestObj['labId'] = this.selectedLabId;
    requestObj['fromDate'] = this.datePipe.transform(this.fromDate.toUTCString(), 'yyyy-MM-dd');
    requestObj['toDate'] = this.datePipe.transform(toFilterDate.toUTCString(), 'yyyy-MM-dd');
    this.loading = true;
    this.libprepworkfileservice.getWorkFileList(requestObj).subscribe(
      results => {
        if (!results.data) {
          this.loading = false;
          return;
        }
        this.libprepworkfilesTotal= results.data.data;
        this.libprepworkfiles= results.data.data.slice(0, 50);
        this.libprepworkfilesDuplicate= results.data.data.slice(0, 50);
        this.rowsCount=this.libprepworkfiles.length;
        this.loading = false;
      },
      error => {
        this.handleError(error);
      }
    );
  }

  isMoreButtonDisabled() {
    if(this.libprepworkfilesTotal ) {
      return (this.libprepworkfiles.length >= this.libprepworkfilesTotal.length) || (this.libprepworkfiles.length == 0) || (this.libprepworkfilesTotal.length == 0) ;
    } else {
      return true;
    }
  }
  moreToshow(){
    this.loading=true;
    this.tableFilterValue ='';
      this.rowsCount += 50;
      setTimeout(() => {
      this.libprepworkfiles=this.libprepworkfilesTotal.slice(0,this.rowsCount );
      this.libprepworkfilesDuplicate=this.libprepworkfilesTotal.slice(0,this.rowsCount );
      this.loading = false; }, 50);
  }

  getRowsCount(){
    return this.libprepworkfiles.length;
  }

  getTotalRowCount(){
    if(this.libprepworkfilesTotal && this.libprepworkfilesTotal.length > 0){
      return this.libprepworkfilesTotal.length;
    }else{
      return 0;
    }
  }

  refreshTableData(){
    this.fromDate = this.getDefaultDate(new Date(), -7);
    this.toDate = this.getDefaultDate(new Date(), 0);
    this.onApplyFilter();
  }

  getTableRowdata(rowData, field){
    if(field =='creationDate'){
      return this.getDate(rowData[field]);
    }else if(rowData[field]){
      return rowData[field];
    }else{
      return '-';
    }
  }
}
